module.exports = __webpack_public_path__ + "ff4577527de89570282b678eb3e692b1.jpg";